import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import { SnCamera } from '@lib/api/entities';
import { SnLocationView } from '@lib/api/services';
import { snFadeOutUp } from '@lib/common/animations';
import { SnMenuItemConfig } from '@lib/ui/menu';

@Component({
  selector: 'sn-camera-list-item',
  templateUrl: './camera-list-item.component.html',
  styleUrls: ['./camera-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [snFadeOutUp],
})
export class SnCameraListItemComponent implements OnInit, OnDestroy {
  @Input() public camera: SnCamera;
  @Input() public actions: SnMenuItemConfig<SnCamera>[] = [];
  @Input() public showLocation: boolean = true;
  @Input() public draggableToMap: boolean;
  public id: string;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _locationViewService: SnLocationView,
    private readonly _changeDetector: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.id = `fs__${this.camera.id}-camera-list-item`;

    this._locationViewService.activeCamera$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      const targetListElement = document.getElementById(this.id);
      if (targetListElement) {
        targetListElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      this._changeDetector.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public isActive(): boolean {
    return this._locationViewService.listCameraActive.indexOf(this.camera.id) > -1;
  }
}
